<script lang="ts">
  import { getContext } from 'svelte';
  import { page } from '$app/stores';
  import { env } from '$env/dynamic/public';
  import { type SanityContext, key } from '$lib/context/sanity';
  import type { SEOAttributes } from '$lib/sanity/schemas/shared/SEO';
  import { isHref } from '$lib/utils/links';
  import { cdnAssetURL } from '$lib/utils/cdn';
  import { flagValue } from '$lib/context/flags';
  import { FEATURE_FLAGS } from '$lib/flags/constants';

  export let seoAttributes: SEOAttributes;

  const { urlBuilder } = getContext<SanityContext>(key);

  const socialShareImage = seoAttributes.image
    ? urlBuilder.image(seoAttributes.image).auto('format').url()
    : '/images/shared/social-share.png';

  $: imgUrl = isHref(socialShareImage) ? socialShareImage : cdnAssetURL(socialShareImage);
  $: pageUrl = `${env.PUBLIC_BASE_URL}${$page.url.pathname}`;
  $: pageTitle =
    seoAttributes.title == 'Block' ? seoAttributes.title : `Block - ${seoAttributes.title}`;

  $: brandReskinEnabled = flagValue(FEATURE_FLAGS.BRAND_RESKIN);
</script>

<svelte:head>
  <!-- Title -->
  <title>{pageTitle}</title>
  <meta property="og:site_name" content={seoAttributes.title} />
  <meta property="og:title" content={seoAttributes.title} />

  <!-- Description -->
  {#if seoAttributes.description}
    <meta name="description" content={seoAttributes.description} />
    <meta property="og:description" content={seoAttributes.description} />
  {/if}

  <!-- Page url -->
  <meta property="og:url" content={pageUrl} />
  <link rel="canonical" href={pageUrl} />

  <meta property="og:type" content="website" />
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="apple-mobile-web-app-capable" content="yes" />
  <meta name="apple-mobile-web-app-status-bar-style" content="black" />

  <meta property="og:image" content={imgUrl} />
  <link rel="apple-touch-icon" href={cdnAssetURL('/apple/apple-touch-icon.png')} />
  <link
    rel="icon"
    href={brandReskinEnabled ? '/brand_reskin/favicon/reskin-064p.png' : '/favicon/064p.png'}
  />

  <link
    rel="alternate icon"
    href={brandReskinEnabled ? '/brand_reskin/favicon/reskin-064p.png' : '/favicon/064p.png'}
  />
</svelte:head>
